/** Brand assets served from this app's public/ folder (no external CDN). */
export const BRAND_LOGO_URL =
  process.env.REACT_APP_BRAND_LOGO_URL || '/ask-logo.png';

export const EMBLEM_URL =
  process.env.REACT_APP_EMBLEM_URL || '/framework-logos/un-emblem.svg';
